import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateRemittanceInstructionRequest } from '../api/requests/create-remittance-instruction-request.ts';
import { createRemittanceInstruction } from '../api/remittance-instructions.ts';

export default function useCreateRemittanceInstruction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateRemittanceInstructionRequest) =>
      createRemittanceInstruction(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['remittanceInstructions'] });
    },
  });
}
